import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const POPUP_TITLE_ERROR_COLOR = '#FF0000';
export const BUTTON_TYPE_PRIMARY = 'primary';

const SPACE = 12;
const HEIGHT = 20;
const CROSS_SIZE = 18;
const CROSS_LEFT = CROSS_SIZE / 2 - 2;
const CROSS_TOP = (HEIGHT - CROSS_SIZE - 2) / 2;

export const Wrapper = styled.div`
    ${FONTS.S};
    color: ${COLORS.TextWhite};

    background: ${COLORS.Control};
    border-radius: 4px;

    padding: ${SPACE}px;
    position: relative;
    margin-right: ${SPACE}px;
`;

export const Title = styled.div``;

export const Cross = styled.div`
    cursor: pointer;

    width: ${CROSS_SIZE}px;
    height: ${CROSS_SIZE}px;
    position: relative;
    height: ${HEIGHT}px;
    margin-left: ${SPACE}px;

    &:after {
        content: '';
        height: ${CROSS_SIZE}px;
        border-left: 2px solid ${props => props.color || `${COLORS.BgMain}`};
        position: absolute;
        transform: rotate(45deg);
        left: ${CROSS_LEFT}px;
        top: ${CROSS_TOP}px;
    }

    &:before {
        content: '';
        height: ${CROSS_SIZE}px;
        border-left: 2px solid ${props => props.color || `${COLORS.BgMain}`};
        position: absolute;
        transform: rotate(-45deg);
        left: ${CROSS_LEFT}px;
        top: ${CROSS_TOP}px;
    }
`;

export const PopupWrapper = styled.div`
    padding: 60px;
    max-width: 500px;

    > * {
      margin-bottom: 28px;
    };

    > *:last-child {
      margin-bottom: unset;
    };
`;

export const PopupTitle = styled.div`
    width: 100%;

    ${FONTS.H2};
    color: ${props => props.color || COLORS.TextWhite};
`;

export const PopupText = styled.div`
    ${FONTS.XS};
`;

export const PopupButtonsWrapper = styled.div`
    justify-content: space-between;
    width: 100%;
`;

export const PopupButton = styled(BaseButton)`
    width:40%;
`;
